import { showDeleteConfirmation } from '@modules/common';
import { switchMap, tap } from 'rxjs/operators';
import { BaseBloc } from '@core/utils/bloc';
import { Repository } from '@core/utils/repository';
import { CompanyResponse, CompanyId } from '@business/entities/companies';
import { handleMessage, requestMessage } from '@business/messages';
import { CompanyAPI } from '@business/api/company';
import { Session } from '@modules/auth/session';
import { R } from '@core/utils/r';
import { PTOUserResponse, TimeoffID } from '@business/entities/pto';
import { TimeoffAPI } from '@business/api/timeoff';
import { TimeOffFormData } from '@modules/timeoff/AddTimeOffModal/AddTimeOffModal';
import { UserId } from '@business/entities/account';

export class TimeoffBloc extends BaseBloc {
  private readonly timeoffRepo = new Repository<PTOUserResponse>({
    getItemId: user => user.id,
  });

  readonly users$ = this.timeoffRepo.items$;
  readonly users = this.timeoffRepo.items;
  readonly selectUser = this.timeoffRepo.selectItem;

  onReset() {
    this.timeoffRepo.reset();
  }

  fetchPTOUsers = () => {
    return TimeoffAPI.fetchUsers().pipe(this.timeoffRepo.ops.reset(), handleMessage({ error: requestMessage('fetch_timeoffs_error') }));
  };

  fetchUserTimeOff = (id: UserId) => {
    return TimeoffAPI.fetchUserTimeoffs(id).pipe(handleMessage({ error: requestMessage('fetch_timeoffs_error') }));
  };

  createTimeoff = (data: TimeOffFormData) => {
    return TimeoffAPI.saveTimeoff(data).pipe(
      handleMessage({
        type: requestMessage('create_timeoff'),
      }),
    );
  };

  updateTimeoff = (id: TimeoffID, data: TimeOffFormData) => {
    return TimeoffAPI.updateTimeoff(id, data).pipe(
      handleMessage({
        type: requestMessage('update_timeoff'),
      }),
    );
  };

  deleteTimeoff = (id: TimeoffID) => {
    return showDeleteConfirmation('Delete Timeoff Request', 'Do you really want to delete this request?').pipe(
      switchMap(() => TimeoffAPI.deleteTimeoff(id)),
      handleMessage({
        type: requestMessage('delete_timeoff'),
      }),
    );
  };
}
